var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51677 7.84244C1.40328 7.66274 1.34654 7.57289 1.31477 7.43431C1.29091 7.33021 1.29091 7.16604 1.31477 7.06195C1.34654 6.92336 1.40328 6.83351 1.51677 6.65381C2.45461 5.16883 5.24617 1.41479 9.50034 1.41479C13.7545 1.41479 16.5461 5.16883 17.4839 6.65381C17.5974 6.83351 17.6541 6.92336 17.6859 7.06195C17.7098 7.16604 17.7098 7.33021 17.6859 7.43431C17.6541 7.57289 17.5974 7.66274 17.4839 7.84244C16.5461 9.32743 13.7545 13.0815 9.50034 13.0815C5.24617 13.0815 2.45461 9.32743 1.51677 7.84244Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50034 9.74813C10.881 9.74813 12.0003 8.62884 12.0003 7.24813C12.0003 5.86742 10.881 4.74813 9.50034 4.74813C8.11962 4.74813 7.00034 5.86742 7.00034 7.24813C7.00034 8.62884 8.11962 9.74813 9.50034 9.74813Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3e60bee15d4b561df732f66f1ab1d72f.svg";
export { ForwardRef as ReactComponent };